export var CRM_SOFTWARE_NAME = /* @__PURE__ */ ((CRM_SOFTWARE_NAME2) => {
  CRM_SOFTWARE_NAME2["SALESFORCE"] = "salesforce";
  CRM_SOFTWARE_NAME2["HUBSPOT"] = "hubspot";
  return CRM_SOFTWARE_NAME2;
})(CRM_SOFTWARE_NAME || {});
